import { useState, useEffect } from 'react';

/**
 * Checks whether an admin or staff member is currently authenticated/logged in.
 * Checks admin_auth as well as any staff credential/session flags in localStorage.
 */
export const isStaffOrAdminLoggedIn = () => {
  if (typeof window === 'undefined') return false;
  try {
    return (
      localStorage.getItem('admin_auth') === 'true' ||
      localStorage.getItem('staff_auth') === 'true' ||
      localStorage.getItem('isStaffLoggedIn') === 'true' ||
      localStorage.getItem('adminLoggedIn') === 'true'
    );
  } catch (e) {
    return false;
  }
};

/**
 * Returns the destination route when exiting a game screen:
 * - Admin or Staff logged in: '/admin' (Admin Dashboard)
 * - Guest / Participant: '/' (Event Home page)
 */
export const getGameExitRoute = () => {
  return isStaffOrAdminLoggedIn() ? '/admin' : '/';
};

/**
 * React hook that provides dynamic exit routing information and reacts to authentication state changes.
 */
export const useGameExitRoute = () => {
  const [isAdminOrStaff, setIsAdminOrStaff] = useState(isStaffOrAdminLoggedIn);

  useEffect(() => {
    const handleAuthChange = () => {
      setIsAdminOrStaff(isStaffOrAdminLoggedIn());
    };

    handleAuthChange();

    window.addEventListener('storage', handleAuthChange);
    window.addEventListener('adminAuthUpdated', handleAuthChange);

    return () => {
      window.removeEventListener('storage', handleAuthChange);
      window.removeEventListener('adminAuthUpdated', handleAuthChange);
    };
  }, []);

  const exitRoute = isAdminOrStaff ? '/admin' : '/';
  const exitTitle = isAdminOrStaff ? 'Back to Dashboard' : 'Back to Home';

  return {
    isAdminOrStaff,
    exitRoute,
    exitTitle
  };
};
